import React from 'react';
import CommonSVGIcon, { Props } from './CommonSVGIcon';

export default function (props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 8 8">
      <path d="M7.33368 1.77502L5.10809 3.99963L7.33368 6.22522L6.22528 7.33362L3.99969 5.10803L1.77509 7.33362L0.666687 6.22522L2.8913 3.99963L0.666687 1.77502L1.77509 0.666626L3.99969 2.89124L6.22528 0.666626L7.33368 1.77502Z"/>
    </CommonSVGIcon>
  );
}
